<div class="row">
  <div class="col-12">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="flexCheckDefault"
        [(ngModel)]="showProcessed"
        [ngModelOptions]="{ standalone: true }"
      />
      <label class="form-check-label" for="flexCheckDefault" tranlsated>SHOW_PROCESSED</label>
    </div>
  </div>
</div>
<div *ngFor="let account of data">
  <div class="row border-top mt-2" *ngIf="!account.processed || (account.processed && showProcessed)">
    <div class="col-md-5">INFO</div>
    <div class="col-md-5">CONTACT</div>
  </div>
  <div class="row" *ngIf="!account.processed || (account.processed && showProcessed)">
    <div class="col-md-5">
      <lib-gung-text-input-horizontal
        gungTranslate="DATE"
        [renderStatic]="true"
        [(ngModel)]="account.creationDate"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="NAME"
        [renderStatic]="true"
        [(ngModel)]="account.companyName"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="CUSTOMER_ID"
        [renderStatic]="true"
        [(ngModel)]="account.companyId"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="ORGANISATION_ID"
        [renderStatic]="true"
        [(ngModel)]="account.companyOrganisationId"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_ORG_NAME"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyOrgName"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="ADDRESS"
        [renderStatic]="true"
        [(ngModel)]="account.companyAddress"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_ZIP_CODE"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyZipCode"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_CITY"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyCity"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COUNTRY"
        [renderStatic]="true"
        [(ngModel)]="account.companyCountry"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_EMAIL_INVOICE"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyEmailInvoice"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_EMAIL_CONFIRMATION"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyEmailConfirmation"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_PHONE"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyPhone"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_PREFERED_CURRENCY"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyPreferedCurrency"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMMENTS"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyComments"
      ></lib-gung-text-input-horizontal>
    </div>
    <div class="col-md-5">
      <lib-gung-text-input-horizontal
        gungTranslate="NAME"
        [renderStatic]="true"
        [(ngModel)]="account.companyContactName"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="TITLE"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyContactTitle"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="EMAIL"
        [renderStatic]="true"
        [(ngModel)]="account.companyContactEmail"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="PHONE"
        [renderStatic]="true"
        [(ngModel)]="account.companyContactPhone"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_DELIVERY_ADDRESS"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyDeliveryAddress"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_DELIVERY_ZIP_CODE"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyDeliveryZipCode"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_DELIVERY_CITY"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyDeliveryCity"
      ></lib-gung-text-input-horizontal>
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY_DELIVERY_COUNTRY"
        [renderStatic]="true"
        [(ngModel)]="account.extra.companyDeliveryCountry"
      ></lib-gung-text-input-horizontal>
      <!-- <div class="form-group row">
          <label class="col-form-label col-12 col-sm-4 font-weight-bold">EXTRA_DATA</label>
          <div class="col">
            <pre>{{account.extra | json}}</pre>
          </div>
        </div> -->
    </div>
    <div class="col-md-2">
      <button
        *ngIf="!account.processed || account.rejected"
        type="button"
        class="btn btn-primary m-1 w-100"
        (click)="createUser(account)"
        translate
      >
        CREATE_USER
      </button>
      <button
        *ngIf="!account.processed || account.rejected"
        type="button"
        class="btn btn-danger m-1 w-100"
        (click)="processed(account)"
        translate
      >
        PROCESSED
      </button>
      <button
        *ngIf="!account.processed"
        type="button"
        class="btn btn-primary m-1 w-100"
        (click)="rejectUser(account)"
        translate
      >
        REJECT_USER
      </button>

      <button
        *ngIf="account.processed && !account.rejected"
        class="btn btn-primary m-1 w-100"
        disabled="disabled"
        translate
      >
        USER_EXISTS
      </button>
      <button
        *ngIf="account.processed && account.rejected"
        class="btn btn-danger m-1 w-100"
        disabled="disabled"
        translate
      >
        USER_REJECTED
      </button>
    </div>
  </div>
</div>
